import { ReactNode, useMemo } from "react";
import ReactDOM from "react-dom";

interface IProps {
    children: ReactNode | ReactNode[] | string;
}

export function Portal(props: IProps) {
    useMemo(() => {
        if (!document.querySelector('#portal-root')) {
            const portalRoot = document.createElement('div');
            portalRoot.id = 'portal-root';
            document.querySelector('body')!.appendChild(portalRoot);
        }
    }, []);

    return ReactDOM.createPortal(props.children, document.querySelector('#portal-root')!);
}
